import { Card, Typography } from "antd";
import { fmtDate } from "../../extensions/utils";
import VisitCntItem from "../visits/visit-cnt-item";
const { Text } = Typography;

const ClientItemSale = ({ item, expanded, onExpand, onItemClose }) => {
  const hasDebt = Number(item.debet) > 0;

  const borderColor = hasDebt ? "#ff4d4f" : "#52c41a";

  return (
    <Card className="client-item-abon-card" style={{ borderLeft: `4px solid ${borderColor}` }} onClick={onExpand}>
      <div className="client-item-abon-card-name-debt-fields">
        <Text strong className="client-item-clip">
          {item.productName}
        </Text>
        <Text strong className="client-item-clip-right" style={{ color: hasDebt ? "#ff4d4f" : undefined }}>
          Долг: {item.debet}
        </Text>
      </div>

      <div className="client-item-abon-card-sum-sale-num-fields">
        <Text className="client-item-clip">#{item.id}</Text>
        <Text className="client-item-clip">Сумма: {item.syma}</Text>
        <Text className="client-item-clip">
          Продажа: {fmtDate(item.docDate)}
        </Text>
      </div>

      <div className="client-item-abon-expand" style={{ maxHeight: expanded ? 800 : 0, opacity: expanded ? 1 : 0,}}>
      {expanded && (
        <div onClick={e => e.stopPropagation()}>
          <VisitCntItem onClose={onItemClose} itemDefault={item} />
        </div>
      )}
      </div>
    </Card>
  );
};

export default ClientItemSale;
